<h1 mat-dialog-title>
  <div class="flex flex-row items-center">
    <div
      class="flex flex-row items-center mx-2 justify-center bg-accent-900 rounded-full h-10 w-10"
    >
      <mat-icon class="icon-size-5" color="primary" [svgIcon]="icon"></mat-icon>
    </div>
    <span class="text-primary">{{ heading }}</span>
  </div>
</h1>
